import { Link } from "react-router-dom";
import type { Booking } from "../../types/company";
import { docSummary, driverName, findDriver, findListing, listingName } from "../../lib/company";
import { useCompany } from "../../lib/companyContext";
import { cn, shortDate, shortDateTime } from "../../lib/format";
import { Card, CardTitle, StatusBadge } from "./ui";
import { useT } from "../../i18n";

interface BookingQueueProps {
  bookings: Booking[];
}

export default function BookingQueue({ bookings }: BookingQueueProps) {
  const t = useT();
  const q = t.company.overview.queue;
  const { state } = useCompany();

  return (
    <Card>
      <div className="mb-2.5 flex items-center justify-between">
        <CardTitle className="mb-0">{q.title}</CardTitle>
        <Link to="/company/bookings" className="text-[13px] text-brand underline hover:text-brand-link">
          {t.common.viewAll}
        </Link>
      </div>

      {bookings.map((b) => {
        const driver = findDriver(state, b.driverId);
        const listing = findListing(state, b.listingId);
        const docs = docSummary(driver);
        return (
          <Link
            key={b.id}
            to={`/company/bookings/${b.id}`}
            className="flex flex-wrap items-center gap-3 border-t border-[#F0F0F0] py-3 text-ink no-underline"
          >
            <div className="min-w-45 flex-1">
              <div className="text-sm font-medium">
                {driverName(driver)} · {listingName(listing)}
              </div>
              <div className="mt-0.5 text-xs text-muted">
                {shortDate(b.start)} → {shortDate(b.end)} · {q.received(shortDateTime(b.createdAt))}
              </div>
            </div>
            <span className={cn("text-xs", docs.className)}>{docs.text}</span>
            <StatusBadge kind="booking" status={b.status} />
          </Link>
        );
      })}

      {bookings.length === 0 && <p className="mt-2 mb-0 text-sm text-faint">{q.empty}</p>}
    </Card>
  );
}
